/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge, Flex, Progress } from "antd";
// import { CalendarIcon } from "../../../../../atoms/CustomIcons";

function PopOverHours(props: any) {
  const { actualHours, totalHours } = props;
  return (
    <div className="crewPopoverContent">
      <div className="crewPopTop">
        <h4>Labor hours</h4>
        {/* <Button
          style={{
            border: "1px solid #dee5e6",
            borderRadius: "6px",
            padding: "5px",
          }}
          className="editCrewBtn"
        >
          <CalendarIcon />
        </Button> */}
      </div>

      <div className="progressBar" style={{ marginBottom: "10px" }}>
        <Flex gap="small" vertical className="LabourProgressBar">
          <Progress
            strokeColor="#00A07D"
            percent={((actualHours ?? 0) / totalHours) * 100}
            size={["100%", 32]}
            style={{ borderRadius: "6px" }}
          />
        </Flex>
      </div>

      <div className="crewPopDetail">
        <div className="crewPopItem">
          <div className="crewWithAvatar">
            <div className="crewPopName">
              <div className="name">
                <Badge color="#00A07D" text="Actual hours"></Badge>
              </div>
            </div>
          </div>
          <div className="crewPopPunchedIn">
            <div
              className="punchedIn"
              style={{
                fontSize: "12px",
                lineHeight: "16px",
                fontWeight: "600",
                color: "#151718",
              }}
            >
              {Number(actualHours) % 1 !== 0
                ? Number(actualHours).toFixed(2)
                : Number(actualHours)}{" "}
              h
            </div>
          </div>
        </div>

        <div className="crewPopItem">
          <div className="crewWithAvatar">
            <div className="crewPopName">
              <div className="name">
                <Badge color="#DEE5E6" text="Available crew hours"></Badge>
              </div>
            </div>
          </div>
          <div className="crewPopPunchedIn">
            <div
              className="punchedIn"
              style={{
                fontSize: "12px",
                lineHeight: "16px",
                fontWeight: "600",
                color: "#151718",
              }}
            >
              {totalHours} h
            </div>
          </div>
        </div>

        <div
          style={{ height: "1px", width: "100%", backgroundColor: "#EFF2F3" }}
        ></div>

        <div className="crewPopItem">
          <div className="crewWithAvatar">
            <div className="crewPopName">
              <div className="name">
                <Badge color="#fff" text="Scheduled hours"></Badge>
              </div>
            </div>
          </div>
          <div className="crewPopPunchedIn">
            <div
              className="punchedIn"
              style={{
                fontSize: "12px",
                lineHeight: "16px",
                fontWeight: "600",
                color: "#151718",
              }}
            >
              {Number(actualHours) % 1 !== 0
                ? Number(actualHours).toFixed(2)
                : Number(actualHours)}{" "}
              h
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopOverHours;
